import type { HelpTranslations } from "../../types/help";

export const help: HelpTranslations = {
  introParagraph:
    "Tere tulemast Franklini abilehele. Siit leiad vastused korduma kippuvatele küsimustele.",
  faqs: [
    {
      question: "Kuidas luua uut hoonet?",
      answer: "Lehel „Minu hooned” klõpsa „Lisa uus hoone”, täida vorm ja kinnita.",
    },
    {
      question: "Kuidas muuta hoone andmeid?",
      answer:
        "Hoone töölaual klõpsa pealkirja all registrikoodil, netopinnal või korruste arvul, et seda muuta. Kõik muu hoone kohta on lehel „Hoone andmed”, kus saad iga väärtuse üle vaadata, kinnitada ja parandada.",
    },
    {
      question: "Mis on lähteülesanne?",
      answer:
        "Lähteülesanne koondab tellija nõuded: projekti lähteülesande kausta failid ja kirjalikud täiendused. Franklin aitab sul seda projekti dokumentidega võrrelda ja juhib tähelepanu võimalikele puudujääkidele või vastuoludele, kuid ülevaatus jääb sinu teha.",
    },
  ],
  faqsTitle: "KKK",
  tosTitle: "Teenusetingimused",
};
